<script setup>
import {computed, onMounted, ref} from 'vue'
import {useAuthStore} from '@/stores/authStores'
import {useMediaStore} from "@/stores/mediaStore"
import api from '@/services/api'
import {useICPStore} from "@/stores/icpStore";
import {keycloak} from '@/main'
import AdminManager from "@/components/leftToolbar/adminManager/AdminManager.vue";

// General

const authStore = useAuthStore()
const clientRoles = keycloak.tokenParsed.resource_access["cairo-metro4-api"].roles;
console.log("Client roles: ", clientRoles);
const currentTime = ref('00:00:00')
const backendStatus = ref('')
const lteStatus = computed(() => {
  return useICPStore().eventData.status === "0" ? "online" : "offline"
})

function updateTime() {
  const now = new Date()
  currentTime.value = now.toLocaleTimeString()
}


function checkBackendStatus() {
  //axios.get('http://metrocairo.magentalab.it:8090/metrics/health')
  api.get('/metrics/health')
      .then(response => {
        backendStatus.value = (response.data.status === 'UP') ? 'online' : 'offline'
      })
      .catch(() => {
        backendStatus.value = 'offline'
      })
}

onMounted(() => {
  updateTime()
  setInterval(updateTime, 1000)

  checkBackendStatus()
  setInterval(checkBackendStatus, 15000)
})

const logout = () => {
  authStore.logout()
}

</script>


<template>
  <div class="toolbar-bottom">
    <!-- Volume Slider -->
    <div class="mb-2 d-flex align-center pa-2">
      <v-icon class="mr-2" size="18">mdi-volume-high</v-icon>
      <v-slider
          v-model="useMediaStore().showValue"
          hide-details
          max="100"
          min="0"
          step="1"
          style="width: 90px; z-index:999"
          @end="useMediaStore().updateVolume"
      />
    </div>

    <!-- Backend Status Icons -->
    <v-card class="mb-1 d-flex justify-center align-center " width="100%">
      <v-icon
          :color="backendStatus === 'online' ? 'green' : (backendStatus === 'offline' ? 'red' : 'grey')"
          class="mr-3"
          size="36"
      >mdi-server
      </v-icon>
      <v-tooltip location="top">
        <template #activator="{ props }">
          <v-icon
              :color="lteStatus === 'online' ? 'green' : 'red'"
              class="mb-2"
              size="36"
              v-bind="props"
          >
            mdi-access-point
          </v-icon>
        </template>
        <span>
      Last notification: {{ useICPStore().eventData.desc }}
    </span>
      </v-tooltip>
    </v-card>

    <!-- Operator Info -->
    <v-card class="pa-1 mb-1 " elevation="0" width="100%">
      <div class="text-caption text-center align-self-center font-weight-bold"> {{ useAuthStore().loggedUserProfile }}
        <div>
          {{ useAuthStore().loggedUser }}
        </div>
      </div>
    </v-card>

    <!-- Logos -->
    <div class="d-flex justify-center align-center ma-2 logos-container">
      <v-img
          alt="Hitachi Logo"
          class="mx-2 logo-img"
          src="/hitachi-3.svg"
      />
      <v-img
          alt="NAT Logo"
          class="mx-2 logo-img"
          src="/NAT_logo.png"
      />
    </div>

    <!-- Admin management tools -->
    <AdminManager v-if="clientRoles.includes('Admin')" />

    <!-- Logout Button -->
    <div class="w-100 mb-2">
      <v-btn block class="mt-0" type="button" @click="logout()">Logout</v-btn>
    </div>

    <!-- Clock -->
    <v-card
        class="pa-1 text-center align-self-center"
        color="blue-grey lighten-4"
        dark
        height="32"
        width="100%"
    >
      {{ currentTime }}
    </v-card>
  </div>
</template>


<style scoped>
.v-navigation-drawer {
  border-right: 1px solid #ccc;
}

.v-card {
  border-radius: 0;
  box-shadow: none;
}

.logos-container {
  width: 100%;
  margin: 0px;

}

.logo-img {
  height: auto;
  object-fit: contain;
}
</style>